//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.UserHome = (function () {
    var myUserHome = {
        Dashboard: function () {
            app.UserHome.InitPreviousCommitteeGrid();
        },
        InitAccountSettings: function () {
            $(document).on('component-bind-edit-mode-complete triggered-UserAccountSettings', function () {
                $('[data-role~="richtext-user"]').each(function (index) {
                    tinymce.remove('#' + this.id);
                    tinymce.init({
                        selector: '#' + this.id, // change this value according to your HTML

                        themes: "modern",
                        plugins: "lists autoresize",
                        mode: "textareas",
                        autoresize_on_init: false,
                        autoresize_bottom_margin: 0,
                        autoresize_min_height: 100,
                        branding: false,
                        menubar: false,
                        forced_root_block: "",
                        toolbar: [
                            'bold italic superscript subscript | numlist bullist | alignleft aligncenter alignright | indent outdent | removeformat'
                        ],
                        init_instance_callback: function (editor) {
                            editor.on('change', function (e) {
                                tinymce.triggerSave();
                                $('#' + e.target.id).change();
                                $('#' + e.target.id).valid();
                            });
                        }
                    });

                    //Hook hidden field into the validation
                    //Tried setting this on the form on creation, on custom validators.... Would not bind correctly
                    //This works the best out of kludge options
                    var form = $(this.form);
                    if (form != undefined) {
                        //create the validator
                        $.validator.unobtrusive.parse(form);
                        //set validator options
                        var validator = form.data('validator');
                        if (validator !== undefined) {
                            validator.settings.ignore =
                                ':hidden:not([data-role~="richtext"]),.mce-content-body';
                        }
                    }
                });
            });
        },
        InitPreviousCommitteeGrid: function () {
            var isAdmin = $("#gridPreviousCommittee").data('is-admin') == 'True';
            var gridColumns = [
                {
                    field: "Name",
                    title: "Title",
                    template: "<a href='#=CommitteeAddress#'>#=Name#</a>",
                    width: "300px"
                },
                {
                    field: "Chair",
                    title: "Chair"
                },
                {
                    field: "Title",
                    title: "Title"
                },
                {
                    field: "DepartmentName",
                    title: "Department Name"
                },
                {
                    field: "Division",
                    title: "Division",
                    hidden: true
                },
                {
                    field: "Department",
                    title: "Department",
                    hidden: true
                },
                {
                    field: "Subdepartment",
                    title: "Subdepartment",
                    hidden: true
                },
                {
                    field: "District",
                    title: "District",
                    hidden: true
                },
                {
                    field: "ExpectedStart",
                    title: "Exp. Start",
                    hidden: true,
                    format: "{0:M/d/yyyy}"
                },
                {
                    field: "ExpectedEnd",
                    title: "Exp. End",
                    format: "{0:M/d/yyyy}",
                    hidden: true
                },
                {
                    field: "ActualStart",
                    title: "Act. Start",
                    format: "{0:M/d/yyyy}"
                },
                {
                    field: "ActualEnd",
                    title: "Act. End",
                    format: "{0:M/d/yyyy}"
                }];

            if (isAdmin) {
                gridColumns.push({
                    template: "<a target='_blank' class='uw-button tiny info remove-rounded-corners' href='#=CommitteeSeatAddress#'>Seat Details</a>"
                });
            }
            $("#gridPreviousCommittee").kendoGrid({
                columns: gridColumns,
                toolbar: ["excel"],
                excel: {
                    fileName: "CommitteeHistory" + app.Committee.ConvertDate(new Date()) + ".xlsx"
                },
                scrollable: false,
                noRecords: true,
                sortable: true,
                columnMenu: true,
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                ActualEnd: { type: "date" },
                                ExpectedEnd: { type: "date" },
                                ExpectedStart: { type: "date" },
                                ActualStart: { type: "date" }
                            }
                        }
                    }
                },
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by",
                        noRecords: "They has never had the pleasure of being on a committee."
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridPreviousCommittee", true);
        },
        InitPreviousElectionGrid: function () {
            $("#gridPreviousElections").kendoGrid({
                columns: [
                    {
                        field: "ElectionTitle",
                        title: "Election Title"
                    },
                    {
                        field: "Committee",
                        title: "Comittee"
                    },
                    {
                        field: "CandidateStatus",
                        title: "Candidate Status"
                    },
                    {
                        field: "Outcome",
                        title: "Election Outcome"
                    },
                    {
                        field: "ExpectedStart",
                        title: "Exp. Start",
                        format: "{0:M/d/yyyy}"
                    },
                    {
                        field: "ExpectedEnd",
                        title: "Exp. End",
                        format: "{0:M/d/yyyy}"
                    }],
                toolbar: ["excel"],
                excel: {
                    fileName: "ElectionHistory" + app.Committee.ConvertDate(new Date()) + ".xlsx"
                },
                scrollable: false,
                noRecords: true,
                sortable: true,
                columnMenu: true,
                messages: {
                    noRecords: "No election records found."
                },
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                ExpectedEnd: { type: "date" },
                                ExpectedStart: { type: "date" }
                            }
                        }
                    }
                },
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridPreviousElections", true);
        }
    };
    return myUserHome;
}());